import { connect } from 'react-redux'
import Disapproved from './disapproved'
import { apiLogout } from '../../../../../../common/api/profile'
import { URLS } from 'pobble-components/dist/setup'

const mapDispatchToProps = dispatch => ({
  onClose: () => {
    apiLogout()
    window.location.href = `${URLS.MARKETING}/for-parents`
  }
})

export default connect(
  null,
  mapDispatchToProps
)(Disapproved)
